import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import {
  GridRow,
  GridColumn,
  Loader,
} from "arv-reactcomponents";

import ProductView from "./ProductView";
import ProductsScrolled from "./ProductsScrolled";

@inject("ProductStore", "CommonStore")
@observer
class ProductList extends Component {
  constructor(props) {
    super(props);

    this.siteHost = window.location.host;
    this.sliceRightLimit = 9;

    this.onWinLoadImgs = this.onWinLoadImgs.bind(this);
    this.triggerChange = this.triggerChange.bind(this);
  }

  componentDidUpdate() {
    this.triggerChange();
  }

  get noOfElementsInRow() {
    const { isDesktop } = this.props.CommonStore;
    if (!isDesktop) {
      return (this.props.ProductStore.gridActive && 2) || 1;
    }

    return 3;
  }

  triggerChange() {
    this.ProductsScrolledRef.triggerChange(
      document.querySelectorAll(".nw-productlist-mainlist")[0],
    );
  }

  onWinLoadImgs(index) {
    return index <= this.sliceRightLimit;
  }

  render() {
    const { list, totalElements } = this.props;
    const { isBlockActiveClassName } = this.props.ProductStore;
    const diffList = (global && global.isServer) ? list.slice(0, this.sliceRightLimit) : list;
    return (
      <Fragment>
        <GridRow className={`nw-productlist ${isBlockActiveClassName}`}>
          <GridColumn className="nw-productlist-mainlist">
            <GridRow itemScope itemType="http://schema.org/ItemList">
              <GridColumn className="nwc-hide">
                <div itemProp="numberOfItems">{list.length}</div>
              </GridColumn>
               {diffList.map((item, index) => (
                <GridColumn
                  itemProp="itemListElement"
                  itemScope
                  itemType="http://schema.org/ListItem"
                  // eslint-disable-next-line react/no-array-index-key
                  key={`${item.id}-${index}`}
                  className="nwc-grid-col-xs-6 nwc-grid-col-sm-4 nw-productlist-eachproduct"
                >
                  <div itemProp="position" className="nwc-hide">
                    {index + 1}
                  </div>
                  <div itemProp="url" className="nwc-hide">
                    {`${this.siteHost}${item.url}`}
                  </div>
                  <div itemProp="image" className="nwc-hide">
                    {item.imagePath}
                  </div>
                  <div itemProp="name" className="nwc-hide">
                    {item.name}
                  </div>
                  <ProductView.component
                    currentIndex={index}
                    index={index}
                    link={item.url}
                    mainImage={item.imagePath}
                    altImage={item.altImagePath}
                    imageWidth={item.imageWidth}
                    imageHeight={item.imageHeight}
                    imageColor={item.imageColor}
                    brandText={item.brand}
                    productTitle={item.name}
                    isNew={item.isNew}
                    discountRange={item.discountRange}
                    mrpRange={item.mrpRange}
                    sellingPriceRange={item.sellingPriceRange}
                    promotions={item.promotions || []}
                    isAllPromotions={this.props.isAllPromotions}
                    styleId={item.id}
                    moreColors={item.moreColors}
                    productTags={item.productTags}
                    onWinLoad={this.onWinLoadImgs(index)}
                  />
                </GridColumn>
              ))}
            </GridRow>
          </GridColumn>
          {totalElements !== list.length && (
            <GridColumn className="nw-productlist-loader">
              <Loader />
            </GridColumn>
          ) || null}
        </GridRow>
        <ProductsScrolled.component
          ref={context => {
            this.ProductsScrolledRef = context;
          }}
          noOfElements={list.length}
          totalElements={totalElements}
          elemsInRow={this.noOfElementsInRow}
        />
      </Fragment>
    );
  }
}

ProductList.wrappedComponent.defaultProps = {
  list: null,
  isAllPromotions: false,
};

ProductList.wrappedComponent.propTypes = {
  isAllPromotions: PropTypes.bool,
  list: PropTypes.arrayOf(PropTypes.object),
  totalElements: PropTypes.number.isRequired,
  CommonStore: PropTypes.shape({
    isDesktop: PropTypes.bool.isRequired,
  }).isRequired,
};

export { default as ColorChip } from "./ColorChip";
export { default as ColorsAvail } from "./ColorsAvail";
export { default as ColorsBlock } from "./ColorsBlock";
export { default as PriceBlock } from "./PriceBlock";
export { default as ProductBtns } from "./ProductBtns";
export { default as ProductModal } from "./ProductModal";
export { default as ProductName } from "./ProductName";
export { default as ProductPromotions } from "./ProductPromotions";
export { default as ProductRightPanel } from "./ProductRightPanel";
export { default as ProductsScrolled } from "./ProductsScrolled";
export { default as ProductView } from "./ProductView";
export { default as PromotionBlock } from "./PromotionBlock";
export { default as SizeBlock } from "./SizeBlock";
export { default as SizeRecommendationBlock } from "./SizeRecommendationBlock";
export { default as PriceInfoBlock } from "./PriceInfoBlock";
export { default as ProductListingBanner } from "./ProductListingBanner";

const getFinalComponent = component =>
  inject("ProductStore", "CommonStore")(observer(component));

  const ProjectComponent = {
  getFinalComponent,
  wrapper: ProductList.wrappedComponent,
  component: ProductList,
};

export default ProjectComponent;